// src/components/Hero.js
import React from 'react';
import colors from '../colors';

function Hero() {
    return (
        <section id="home" style={styles.hero}>
            <h2 style={styles.tagline}>
                Every meme coin has two lives, the second one starts when you realize there is only one!
            </h2>
            {/*<p style={styles.contract}>*/}
            {/*    CA: 45BqdUDB74RVXXLPLXA3UHsNzXydtqCEEtZWDyZhjQeg*/}
            {/*</p>*/}

        </section>
    );
}


const styles = {
    hero: {
        textAlign: 'center',
        padding: '100px 20px',
        backgroundColor: colors.primaryDark,
    },
    tagline: {
        fontSize: '1.5rem',
        color: colors.textLight,
        maxWidth: '800px',
        margin: '0 auto',
        lineHeight: '1.5',
    },
    contract: {
        fontSize: '1rem',
        color: colors.textLight,
        marginTop: '30px',
        wordBreak: 'break-all', // ensures CA wraps nicely
    },
};

export default Hero;